/**
 * Ссылка-приглашение: внутри MAX — deep link бота, иначе обычный адрес игры.
 * Код в обычной ссылке оставляем кириллицей как есть — так её видно и можно
 * прочитать вслух; браузер сам закодирует символы при переходе.
 */
export function inviteLink(code: string, botName: string): string {
  return botName
    ? `https://max.ru/${botName}?startapp=${encodeURIComponent(code)}`
    : `${window.location.origin}/?i=${code}`
}

/**
 * Достаёт код из адреса (`/?i=БЕЛКА-482`) и сразу убирает параметр,
 * чтобы перезагрузка страницы не пыталась добавить друга второй раз.
 */
export function takeInviteFromUrl(): string {
  const params = new URLSearchParams(window.location.search)
  const code = params.get('i') || ''
  if (!code) {
    return ''
  }

  params.delete('i')
  const query = params.toString()
  // Фрагмент сохраняем: в нём может лежать ключ восстановления, который
  // читают следом, — стереть его здесь значило бы потерять молча.
  const rest = `${query ? `?${query}` : ''}${window.location.hash}`
  window.history.replaceState(null, '', `${window.location.pathname}${rest}`)

  return code
}

/**
 * Ссылка с ключом восстановления — её ребёнок отправляет родителям.
 *
 * Ключ живёт во фрагменте, а не в query: фрагмент не уходит на сервер, значит
 * не оседает в логах прокси, в Referer и в превью мессенджеров. Диплинк бота
 * тут не годится — `?startapp=` уже занят кодом приглашения.
 */
export function restoreLink(code: string): string {
  return `${window.location.origin}/#k=${code}`
}

/** Ключ из адреса. Читаем и фрагмент, и query: не все мессенджеры их берегут. */
export function takeRestoreFromUrl(): string {
  const hash = window.location.hash.replace(/^#/, '')
  const fromHash = new URLSearchParams(hash).get('k') || ''
  const params = new URLSearchParams(window.location.search)
  const code = fromHash || params.get('k') || ''
  if (!code) {
    return ''
  }

  params.delete('k')
  const query = params.toString()
  window.history.replaceState(null, '', `${window.location.pathname}${query ? `?${query}` : ''}`)

  return code
}
